import type { SlotConfig } from '@/components/atomic/input-v2/types'

import { useLayoutEffect, useRef, useState } from 'react'

export const useSlotPadding = (
  leftSlot?: SlotConfig,
  rightSlot?: SlotConfig,
) => {
  const leftSlotRef = useRef<HTMLDivElement>(null)
  const rightSlotRef = useRef<HTMLDivElement>(null)

  const [leftPadding, setLeftPadding] = useState(0)
  const [rightPadding, setRightPadding] = useState(0)

  useLayoutEffect(() => {
    const updatePadding = () => {
      // Calculate left padding
      if (leftSlot && leftSlotRef.current) {
        const width = leftSlotRef.current.offsetWidth
        const separatorPadding = leftSlot.showSeparator !== false ? 12 : 0
        setLeftPadding(width + separatorPadding)
      } else {
        setLeftPadding(0)
      }

      // Calculate right padding
      if (rightSlot && rightSlotRef.current) {
        const width = rightSlotRef.current.offsetWidth
        const separatorPadding = rightSlot.showSeparator !== false ? 12 : 0
        setRightPadding(width + separatorPadding)
      } else {
        setRightPadding(0)
      }
    }

    updatePadding()
  }, [leftSlot, rightSlot])

  return {
    leftSlotRef,
    rightSlotRef,
    leftPadding,
    rightPadding,
  }
}
